import { ArtistMessage } from "../../types/ArtistMessage";

export type Corners = { 
    northeast: { latitude: number, longitude: number },
    southwest: { latitude: number, longitude: number }
}

export const getOuterCorners = (artistMessages: ArtistMessage[]): Corners => {
    const validMessages = artistMessages.filter(x => x.coordinates !== undefined);
    if (validMessages.length === 0) {
        return {
            northeast: {
                latitude: 40,
                longitude: 100,
            },
            southwest: {
                latitude: -40,
                longitude: -100,
            }
        };
    }
    
    let south = validMessages.reduce((acc, am)=> (acc.coordinates?.latitude ?? 0) < (am.coordinates?.latitude ?? 0) ? acc : am);
    let west = validMessages.reduce((acc, am)=> (acc.coordinates?.longitude ?? 0) < (am.coordinates?.longitude ?? 0) ? acc : am);
    let north = validMessages.reduce((acc, am)=> (acc.coordinates?.latitude ?? 0) > (am.coordinates?.latitude ?? 0) ? acc : am);
    let east = validMessages.reduce((acc, am)=> (acc.coordinates?.longitude ?? 0) > (am.coordinates?.longitude ?? 0) ? acc : am);

    return { 
        northeast: { latitude: north.coordinates?.latitude ?? 0, longitude: east.coordinates?.longitude ?? 0 },
        southwest: { latitude: south.coordinates?.latitude ?? 0, longitude: west.coordinates?.longitude ?? 0 }
    }
}